import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBasedQuery';
import { HTTP_METHODS } from '../../utils/handler';
import { API_BASE_URL } from '../../config';

const { GET, PUT } = HTTP_METHODS;

// ✅ API Routes
const GET_HRX_ROLE = '/hrx-role/get-hrx-role';
const GET_HRX_ROLE_BY_ID = (id) => `/hrx-role/${id}`;

export const systemRoleApi = createApi({
  reducerPath: 'systemRoleApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    // 🔹 Get all roles
    getSystemRole: builder.query({
      query: (params) => ({
        url: GET_HRX_ROLE,
        method: GET,
        params
      })
    }),

    // 🔹 Get role by ID
    getSystemRoleById: builder.query({
      query: (id) => ({
        url: GET_HRX_ROLE_BY_ID(id),
        method: GET
      })
    }),
    updateSystemRole: builder.mutation({
      query: ({ id, body }) => ({
        url: `/hrx-role/${id}`,
        method: PUT,
        data: body
      }),
      invalidatesTags: ['SystemRole']
    })
  })
});

export const { useGetSystemRoleQuery, useGetSystemRoleByIdQuery, useUpdateSystemRoleMutation } =
  systemRoleApi;
